import { createSlice } from '@reduxjs/toolkit';
import { defaultLang, supportedLangs} from "../../config/i18nConfig";

import it from './lang/it.json'
import en from './lang/en.json'
import BRAND from '../../brand/config';

const LANG_KEY = 'lang'
const base = { it, en }

// brand strings over the base ones: objects are merged, everything else (arrays included) is replaced
const merge = (base, over) => Object.fromEntries(Object.keys({...base, ...over}).map(k => [k,
  over?.[k]?.constructor === Object && base?.[k]?.constructor === Object ? merge(base[k], over[k]) : (k in over ? over[k] : base[k])
]))

// keys missing in a language fall back to the default one
const build = (lang) => [base[defaultLang], BRAND.strings[defaultLang], base[lang], BRAND.strings[lang]]
  .reduce((acc, s) => merge(acc, s || {}), {})

const savedLang = () => { try { return localStorage.getItem(LANG_KEY) } catch { return null } }

// saved choice first, then the device languages, then english (foreign devices)
const initialLang = [savedLang(), ...(navigator.languages || [navigator.language])]
  .map(l => l?.slice(0, 2).toLowerCase())
  .find(l => l in supportedLangs) || 'en'

document.documentElement.lang = initialLang

const initialState = {
  lang: initialLang,
  supportedLangs: { ...supportedLangs },
  translations: Object.fromEntries(Object.keys(supportedLangs).map(l => [l, build(l)])),
};
export const i18nSlice = createSlice({
  name: "i18n",
  initialState,
  reducers: {
    setLang: (state, action) => { state.lang = action.payload },
  },
});

export const changeLang = (lang) => (dispatch) => {
  try { localStorage.setItem(LANG_KEY, lang) } catch {}
  document.documentElement.lang = lang
  dispatch(i18nSlice.actions.setLang(lang))
}

export const selectTranslations = (state) => state.i18n.translations[state.i18n.lang];
export const selectCurrentLang = (state) => state.i18n.lang;
export const selectSupportedLangs = (state) => state.i18n.supportedLangs;

export default i18nSlice.reducer;
